(() => {

  const nav = document.getElementById('nav');
  if (nav) {
    const onScroll = () => { nav.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

    const navToggle = document.getElementById('navToggle');
    if (navToggle) navToggle.addEventListener('click', () => nav.classList.toggle('open'));
    document.querySelectorAll('.nav-links a').forEach(a => a.addEventListener('click', () => nav.classList.remove('open')));
  }

  document.querySelectorAll('.split-word').forEach(el => {
    if (!el.querySelector(':scope > span')) {
      const t = el.textContent;
      el.textContent = '';
      const s = document.createElement('span');
      s.textContent = t;
      el.appendChild(s);
    }
  });

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, {threshold:.12, rootMargin:'0px 0px -60px 0px'});
  document.querySelectorAll('.reveal, .split-word').forEach(el => io.observe(el));

  // Ken Burns animation drives motion on the hero image now (CSS @keyframes heroKen).
  // Mouse parallax is intentionally omitted for the lifestyle photo — the natural
  // photo composition + slow zoom + reveal fade already provide sufficient motion.
  const bottle = document.querySelector('.hero-bottle');
  if (bottle && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
    // subtle scroll-linked drift on top of the ken burns
    window.addEventListener('scroll', () => {
      const sy = Math.min(window.scrollY, 600) * .06;
      bottle.style.setProperty('--scroll-y', `-${sy}px`);
    }, {passive:true});
  }

  // ── formula cards: tap-toggle detail on touch devices
  const formulaCards = document.querySelectorAll('.lp-form-card');
  const isTouch = window.matchMedia('(hover:none)').matches;
  formulaCards.forEach(card => {
    card.addEventListener('click', (e) => {
      if (isTouch) {
        e.preventDefault();
        // close others
        formulaCards.forEach(c => { if (c !== card) c.classList.remove('is-active'); });
        card.classList.toggle('is-active');
      }
    });
    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        formulaCards.forEach(c => { if (c !== card) c.classList.remove('is-active'); });
        card.classList.toggle('is-active');
      }
    });
  });
  // close active card when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.lp-form-card')) {
      formulaCards.forEach(c => c.classList.remove('is-active'));
    }
  });

  // ── voices marquee: CSS animation (auto) + manual nav (temporary offset)
  const voicesWrap = document.getElementById('voicesWrap');
  const voicesTrack = document.getElementById('voicesTrack');
  const voicePrev = document.getElementById('voicePrev');
  const voiceNext = document.getElementById('voiceNext');
  if (voicesWrap && voicesTrack && voicePrev && voiceNext) {
    let resumeTimer;
    let manualX = 0;
    const cardStep = () => {
      const first = voicesTrack.querySelector('.voice');
      return first ? first.offsetWidth + 24 : 400;
    };
    // capture running CSS animation position, switch to manual mode
    const enterManual = () => {
      if (!voicesTrack.classList.contains('is-manual')) {
        const style = getComputedStyle(voicesTrack);
        const matrix = new DOMMatrixReadOnly(style.transform);
        manualX = matrix.m41 || 0;
        // disable CSS animation, take control via inline transform
        voicesTrack.classList.add('is-manual');
        voicesTrack.style.transform = 'translateX(' + manualX + 'px)';
      }
    };
    const nudge = (dir) => {
      enterManual();
      const step = cardStep() * dir;
      const halfWidth = voicesTrack.scrollWidth / 2;
      manualX -= step;
      // wrap around infinitely
      while (manualX <= -halfWidth) manualX += halfWidth;
      while (manualX > 0) manualX -= halfWidth;
      voicesTrack.style.transition = 'transform .6s cubic-bezier(.2,.7,.15,1)';
      voicesTrack.style.transform = 'translateX(' + manualX + 'px)';
      // resume auto animation after 4s of inactivity
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        voicesTrack.style.transition = '';
        voicesTrack.style.transform = '';
        voicesTrack.classList.remove('is-manual');
      }, 4000);
    };
    voicePrev.addEventListener('click', () => nudge(-1));
    voiceNext.addEventListener('click', () => nudge(1));
  }

  // ── gauge fills + counters (concern section stats)
  const gauges = document.querySelectorAll('.gauge');
  const gnums = document.querySelectorAll('.gauge-num[data-count]');
  const gio = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      if (el.classList.contains('gauge')) {
        el.style.setProperty('--val', el.dataset.val);
        el.classList.add('in');
      } else if (el.classList.contains('gauge-num')) {
        const target = parseInt(el.dataset.count,10);
        const unitEl = el.querySelector('.unit');
        const unit = unitEl ? unitEl.outerHTML : '';
        const dur = 2000, start = performance.now();
        const step = now => {
          const p = Math.min(1,(now-start)/dur);
          const val = Math.round(target*(1-Math.pow(1-p,3)));
          el.innerHTML = val + unit;
          if (p<1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
      gio.unobserve(el);
    });
  }, {threshold:.4});
  gauges.forEach(g => gio.observe(g));
  gnums.forEach(g => gio.observe(g));

  const reelFrame = document.getElementById('reelFrame');
  const reelVideo = document.getElementById('reelVideo');
  const reelPlay = document.getElementById('reelPlay');
  const reelMute = document.getElementById('reelMute');
  const muteIcon = document.getElementById('muteIcon');
  if (reelFrame && reelVideo) {
    let userStarted = false;
    const playMuted = () => {
      if (userStarted) return;
      reelVideo.muted = true;
      reelVideo.play().then(() => reelFrame.classList.add('playing')).catch(()=>{});
    };
    const playWithSound = () => {
      userStarted = true;
      reelVideo.muted = false;
      reelVideo.currentTime = 0;
      reelVideo.play().then(() => reelFrame.classList.add('playing')).catch(()=>{});
    };
    if (reelPlay) reelPlay.addEventListener('click', playWithSound);
    if (reelMute) reelMute.addEventListener('click', e => {
      e.stopPropagation();
      reelVideo.muted = !reelVideo.muted;
      if (muteIcon) muteIcon.innerHTML = reelVideo.muted
        ? '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor" stroke="none"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/>'
        : '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor" stroke="none"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/>';
    });
    const rio = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting && e.intersectionRatio > .4) playMuted();
        else if (!userStarted) { reelVideo.pause(); reelFrame.classList.remove('playing'); }
      });
    }, {threshold:[0, .4, .8]});
    rio.observe(reelFrame);
  }

  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        document.querySelector(id).scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });

})();